/** A compact text wordmark for navigation; its parent link provides the name. */
export function ConsoleLogo() {
  return <span className="ops-brand-logo console-wordmark" aria-hidden="true"><span>player</span><span className="console-wordmark-accent">one</span></span>;
}
